import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Course, CourseList, CourseSlide, CourseTest } from 'src/app/shared/models/course';
import { CourseService } from 'src/app/shared/services/course.service';
import { ExamAttendComponent } from '../exam-attend/exam-attend/exam-attend.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { Router } from '@angular/router';
import { Context } from 'src/app/shared/models/context';
import { AuthService } from 'src/app/shared/services/auth.service';
import * as bootstrap from 'bootstrap';
import { ConfirmationsPopupComponent } from '../confirmation-popup/confirmations-popup.component';



@Component({
  selector: 'app-emp-course-test-crud',
  templateUrl: './emp-course-test-crud.component.html',
  styleUrls: ['./emp-course-test-crud.component.scss']
})
export class EmpCourseTestCrudComponent implements OnInit {

  @Input() course: CourseList;
  slides: CourseSlide[] = [];
  currentSlideIndex: number = 0;
  public context!: Context;
  constructor(private courseService: CourseService, public activeModal: NgbActiveModal,
    private modalService: NgbModal, private commonService: CommonService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentSlideIndex = 0;
    this.context = this.authService.getContextData();
    this.loadCourseSlides();
  }

  public onSlide(event: any) {
    this.currentSlideIndex = event.to;
  }

  private loadCourseSlides() {
    this.courseService.getCourseSlides(this.course?.courseId, false).subscribe({
      next: (slides: CourseSlide[]) => {
        this.slides = slides.sort((a, b) => a.sequence - b.sequence);
      },
      error: (error: HttpErrorResponse) => {
        console.error("Error fetching slides", error);
      }
    });
  }

  public attendExam(course: CourseList) {
    this.courseService.getEmployeeIsAttend(this.context.employeeId, course.courseTestId).subscribe({
      next: (isAllowed: boolean) => {
        if (isAllowed) {
          this.commonService.setToastr(400, "You are not allowed to attend this exam.");
          return;
        }
        const modalRef = this.modalService.open(ExamAttendComponent, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.course = course;
        modalRef.componentInstance.context = this.authService.getContextData();
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }


  public confirmCloseModal(course: CourseList) {
    const modalRef = this.modalService.open(ConfirmationsPopupComponent);
    modalRef.componentInstance.title = "Confirm Exam Attendance";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to attend the exam?";
    modalRef.componentInstance.message = "This action will start the exam.";
    modalRef.componentInstance.label = "Attend Exam";
    modalRef.result.then(
      (result) => {
        if (result === true) {
          this.activeModal.close();
          this.attendExam(course);
        }
      },
      (dismissed) => {
        if (dismissed === 'cancel click') {
          this.currentSlideIndex = 0;
          const carousel = document.querySelector('#carouselExampleIndicators') as any;
          if (carousel) {
            new bootstrap.Carousel(carousel).to(0);
          }
        }
      }
    );
  }
}
